import { render, staticRenderFns } from "./jtysyd.vue?vue&type=template&id=05cb0a42&"
import script from "./jtysyd.vue?vue&type=script&lang=js&"
export * from "./jtysyd.vue?vue&type=script&lang=js&"
import style0 from "./jtysyd.vue?vue&type=style&index=0&id=05cb0a42&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports